<template>

  <div v-show="show_noconnection" class="noconnection-page">
    <div class="sc-header">
      <div class="sc-header--title">{{ projectTitleName }} 腦力健身房</div>
      <div class="sc-header--close-button" @click="onClose('')">
        <div></div>
      </div>
    </div>

    <div class="noconnection-page-box">
      <div class="box-jinimg">
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>
        <div v-if="noconnectionType === 'network'" class="symbol"></div>


        <div class="box-jinimg-container">
          <img v-if="noconnectionType === 'firebase'" src='@/assets/img_warning.png' alt="">
          <img v-else :src=noconnectionImageUrl alt="">
        </div>
        <div class="box-jinimg-shadow"></div>
      </div>

      <div class="box-description">
        <div class="box-description-container">
          <div class="box-description-title">{{ descriptionTitle }}</div>
          <div class="box-description-text"></div>
        </div>

        <div class="refresh-btn">
          <img class="refresh-btn-img" @click="noconnection_closeModal" :src=noconnection_icon_refresh>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
export default {
  props: {
    show_noconnection: {
      type: Boolean,
      default: () => false
    },
    projectTitleName: {
      type: String,
      default: () => ''
    },
    noconnectionImageUrl: {
      type: String,
      default: () => ''
    },
    noconnection_icon_refresh: {
      type: String,
      default: () => ''
    },
    onClose: {
      type: Function,
      required: true
    },
    noconnection_closeModal: {
      type: Function,
      required: true
    },
    noconnectionType: {
      type: String,
      required: false,
      default: 'defalut'
    },
  },
  computed: {
    descriptionTitle() {
      switch (this.noconnectionType) {
        case 'firebase':
            return '出現錯誤，請重新嘗試'
        default:
          return '請連接上網路後使用'
      }
    },
  },
  data() {
    return {
    }
  }
}
</script>
<style scoped>
@import "./styles/noconnectionpage.css";
</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/Noconnection.vue